import {Component, Input} from '@angular/core';
import {Params, RouterLink} from '@angular/router';

@Component({
    selector: 'app-operations-back-link',
    standalone: true,
    imports: [RouterLink],
    template: `
        <a class="operations-back-link"
           [routerLink]="routerLink"
           [queryParams]="queryParams || null">{{ label }}</a>
    `,
    styles: [`
        .operations-back-link {
            display: inline-flex;
            align-items: center;
            gap: 0.35rem;
            margin-bottom: 0.5rem;
            padding: 0;
            border: 0;
            background: transparent;
            color: #1D4ED8;
            font-size: 0.875rem;
            font-weight: 600;
            text-decoration: none;
            cursor: pointer;
        }

        .operations-back-link:hover {
            text-decoration: underline;
        }
    `],
})
export class OperationsBackLinkComponent {
    @Input({required: true}) routerLink!: string | string[];
    @Input() queryParams: Params | null = null;
    @Input() label = '← Back';
}
